import { useContext, useEffect, useState } from "react";
import Modal from "components/ui/modal/modal";
import Button from "components/ui/controls/button/button";
import { FaCogs, FaTable, FaEdit, FaTrashAlt } from "react-icons/fa";
import ContributionSpecifique from "components/app/AuditComplet/SituationPro/ContributionSpecifique";
import Column from "components/ui/layout/column/column";
import { applyFormat } from "components/ui/ui-helpers";
import Row from "components/ui/layout/row/row";
import { AppContext } from "components/app/RemExprertProvider";
import ActionButton from "components/ui/controls/action-button";
import DropDown from "components/ui/controls/drop-down/drop-down";
import Pager from "components/ui/controls/pager/pager";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import TextField from "components/ui/controls/text-field/text-field";
import { CalculRetraite } from "components/app/Api/Retraite/ApiRetraite";

function AutresPensionsModal(props) {
  const [modalOpen, setmodalOpen] = useState(false);
  const context = useContext(AppContext);
  const [DateDepartRetraite, SetDateDepartRetraite] = useState(null);
  const [DateDepartRetraiteTauxPlein, SetDateDepartRetraiteTauxPlein] = useState(null);
  const [ageDepartRetraite, setAgeDepartRetraite] = useState({ ans: 0, mois: 0 });
  const [ageDepartTauxPlein, setAgeDepartTauxPlein] = useState({ ans: 0, mois: 0 });
  const [pensionsData, setPensionsData] = useState({});
  const [libelle, setLibelle] = useState("");
  const [prelevementsSociaux, setPrelevementsSociaux] = useState("0");
  const [editingPensionId, setEditingPensionId] = useState(null);
  const handleCalculRetraite = () => {
    CalculRetraite(context.state, "", 0, props.ClientConjoint).then((ResultatRetraite) => {
      const dateRetraite = new Date(ResultatRetraite.RetraiteChoixDepartRetraite.Infos.DateDepartRetraite);
      const dateTauxPlein = new Date(ResultatRetraite.RetraiteTauxPlein.Infos.DateDepartRetraite);
      SetDateDepartRetraite(dateRetraite);
      SetDateDepartRetraiteTauxPlein(dateTauxPlein);
      
      // Récupérer les âges
      setAgeDepartRetraite({
        ans: ResultatRetraite.RetraiteChoixDepartRetraite.Infos.AgeDepartRetraite2 || 0,
        mois: ResultatRetraite.RetraiteChoixDepartRetraite.Infos.MoisDepartRetraite2 || 0
      });
      setAgeDepartTauxPlein({
        ans: ResultatRetraite.RetraiteTauxPlein.Infos.AgeDepartRetraite2 || 0,
        mois: ResultatRetraite.RetraiteTauxPlein.Infos.MoisDepartRetraite2 || 0
      });
    });
  };
  useEffect(() => {
    handleCalculRetraite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Column>
        <Row tpad>
          <Column>
            <ActionButton 
              onClick={() => {
                setEditingPensionId(null);
                setPensionsData({});
                setLibelle("");
                setPrelevementsSociaux("0");
                setmodalOpen(true);
              }} 
              icon={<FaCogs />} 
              title="Ajouter une autre pension" 
            />
          </Column>
        </Row>
        <Row>
          <Column fill>
            {context.state[props.Outil + "TabAutresPensions" + props.ClientConjoint]?.length === 0 ? (
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  border: "1px dashed #d1d5db",
                  borderRadius: "8px",
                  padding: "16px",
                  textAlign: "center",
                  color: "#6b7280",
                  width: "100%",
                }}
              >
                Aucune autre pension n'a été ajoutée
              </div>
            ) : (
              context.state[props.Outil + "TabAutresPensions" + props.ClientConjoint]?.map((Infos, Index) => (
                <div className="contrat-card" key={Infos.id || "contSpe" + Index}>
                  <div className="contrat-card-content">
                    <div className="contrat-card-icon">{/* <FaCoins style={{fontSize:"14px"}} /> */}</div>

                    <div className="contrat-card-info">
                      <h4 className="contrat-card-title">{Infos.libelle}</h4>
                      <div className="contrat-card-meta">
                        <span className="contrat-card-badge">
                          Prélèvements sociaux : {Infos.prelevementsSociaux}%
                        </span>
                      </div>
                      {Infos.pensions && Infos.pensions.length > 0 && (
                        <div className="contrat-card-meta">
                          <span className="contrat-card-badge">
                            Pension brute : {applyFormat(Infos.pensions[0].pensionBrute, "uint", { thousands: " ", unit: " €" })} / 
                            Pension nette : {applyFormat(Infos.pensions[0].pensionNette, "uint", { thousands: " ", unit: " €" })}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Button
                      onClick={() => {
                        // Charger les données pour modification
                        setEditingPensionId(Infos.id);
                        setLibelle(Infos.libelle);
                        setPrelevementsSociaux(Infos.prelevementsSociaux);

                        // Reconstruire les dates pour l'édition
                        const allDates = [];
                        if (DateDepartRetraite) {
                          for (let offset = 0; offset <= 5; offset++) {
                            const date = new Date(DateDepartRetraite);
                            date.setFullYear(date.getFullYear() + offset);
                            allDates.push({ date, isTauxPlein: false });
                          }
                          if (DateDepartRetraiteTauxPlein && DateDepartRetraiteTauxPlein instanceof Date) {
                            const tauxPleinTime = DateDepartRetraiteTauxPlein.getTime();
                            const insertIndex = allDates.findIndex((d) => d.date.getTime() > tauxPleinTime);
                            if (insertIndex !== -1) {
                              allDates.splice(insertIndex, 0, { date: new Date(DateDepartRetraiteTauxPlein), isTauxPlein: true });
                            } else {
                              allDates.push({ date: new Date(DateDepartRetraiteTauxPlein), isTauxPlein: true });
                            }
                          }
                        }
                        
                        // Charger les pensions dans le state
                        const pensionsDataToEdit = {};
                        const normalPensions = Infos.pensions.filter(p => !p.isTauxPlein);
                        const tauxPleinPension = Infos.pensions.find(p => p.isTauxPlein);

                        const normalDates = allDates.filter(d => !d.isTauxPlein);
                        normalDates.sort((a, b) => a.date - b.date);
                        
                        normalPensions.forEach((pension, index) => {
                          if (normalDates[index]) {
                            const dateKey = normalDates[index].date.toISOString();
                            pensionsDataToEdit[dateKey] = { ...pension, date: dateKey };
                          }
                        });

                        if (tauxPleinPension) {
                          const tauxPleinDate = allDates.find(d => d.isTauxPlein);
                          if (tauxPleinDate) {
                            const dateKey = tauxPleinDate.date.toISOString();
                            pensionsDataToEdit[dateKey] = { ...tauxPleinPension, date: dateKey };
                          }
                        }

                        setPensionsData(pensionsDataToEdit);
                        setmodalOpen(true);
                      }}
                      icon
                      style={{
                        display: "inline-flex",
                        padding: "8px",
                        backgroundColor: "#f0fff4",
                        border: "none",
                        borderRadius: "6px",
                      }}
                    >
                      <FaEdit style={{ color: "#22c55e" }} />
                    </Button>
                    <Button
                      onClick={() => {
                        // Supprimer la pension par ID
                        const currentTab = context.state[props.Outil + "TabAutresPensions" + props.ClientConjoint] || [];
                        const updatedTab = currentTab.filter(p => p.id !== Infos.id);
                        context.handleValueChange(
                          [props.Outil + "TabAutresPensions" + props.ClientConjoint],
                          updatedTab
                        );
                      }}
                      icon
                      style={{
                        display: "inline-flex",
                        padding: "8px",
                        backgroundColor: "#fff5f5",
                        border: "none",
                        borderRadius: "6px",
                      }}
                    >
                      <FaTrashAlt style={{ color: "#f56565" }} />
                    </Button>
                  </div>
                </div>
              ))
            )}
          </Column>
        </Row>
      </Column>
      <Modal
        width="75%"
        height="80%"
        title={editingPensionId ? "Modifier la pension" : "Ajouter une pension"}
        icon={<FaCogs />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
          setEditingPensionId(null);
          setPensionsData({});
          setLibelle("");
          setPrelevementsSociaux("0");
        }}
        className="modal-ris-left"
      >
        <Pager
          pages={[
            {
              content: (
                <Column pad>
                  <CardBox>
                    <Column fill>
                      <Row tpad>
                        <div className="prise-en-charge-container prise-en-charge-table-container">
                          <table className="mono">
                            <tbody>
                              <tr>
                                <td>
                                  <label className="prise-en-charge-cell-label">Libellé</label>
                                  <TextField value={libelle} onChange={(evt, value) => setLibelle(value)} laarge />
                                </td>
                                <td>
                                  <label className="prise-en-charge-cell-label">Prélèvements sociaux</label>
                                  <DropDown
                                    value={prelevementsSociaux}
                                    options={[
                                      {
                                        value: "0",
                                        label: "0%",
                                      },
                                      {
                                        value: "9.10",
                                        label: "9,10%",
                                      },
                                      {
                                        value: "10.10",
                                        label: "10,10%",
                                      },
                                    ]}
                                    onChange={(evt) => {
                                      const newPrelevements = evt.target.value;
                                      setPrelevementsSociaux(newPrelevements);
                                      
                                      // Recalculer toutes les pensions nettes si des pensions brutes existent
                                      const updatedPensionsData = {};
                                      Object.keys(pensionsData).forEach(dateKey => {
                                        const pension = pensionsData[dateKey];
                                        if (pension.pensionBrute) {
                                          const prelevements = parseFloat(newPrelevements) || 0;
                                          const pensionBrute = parseFloat(pension.pensionBrute) || 0;
                                          const pensionNette = pensionBrute - (pensionBrute * prelevements / 100);
                                          
                                          updatedPensionsData[dateKey] = {
                                            ...pension,
                                            pensionNette: pensionNette.toFixed(0)
                                          };
                                        } else {
                                          updatedPensionsData[dateKey] = pension;
                                        }
                                      });
                                      
                                      if (Object.keys(updatedPensionsData).length > 0) {
                                        setPensionsData(updatedPensionsData);
                                      }
                                    }}
                                    normal
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <Row style={{ marginTop: "0px" }}>
                            <Column fill>
                              <CardBoxHeader icon={<FaTable style={{ color: "#6b7280", fontSize: 14 }} />}>
                                <span
                                  style={{
                                    color: "rgb(55, 65, 81)",
                                    fontSize: 14,
                                    fontWeight: 600,
                                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                    letterSpacing: "-0.01em",
                                  }}
                                >
                                  Tableau des prestations périodiques
                                </span>
                              </CardBoxHeader>
                              {/* Column headers for the list */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  maxWidth: 850,
                                  margin: "8px 0 8px 0",
                                  paddingLeft: 12,
                                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                  fontSize: 13,
                                  color: "#64748b",
                                  fontWeight: 600,
                                  letterSpacing: "-0.01em",
                                }}
                              >
                                <span style={{ width: 170, marginRight: 18, textAlign: "center", display: "inline-block" }}>Age</span>
                                <span style={{ width: 90, marginLeft: 8, textAlign: "center", display: "inline-block" }}>Date</span>
                                <span style={{ width: 106, marginRight: 8, textAlign: "center", display: "inline-block" }}></span>
                                <span style={{ width: 150, marginLeft: 30, textAlign: "center", display: "inline-block" }}>Pension brute annuelle</span>
                                <span style={{ width: 150, marginLeft: 25, textAlign: "center", display: "inline-block" }}>Pension nette annuelle</span>
                              </div>
                              <ul
                                style={{
                                  listStyle: "none",
                                  padding: 0,
                                  margin: 0,
                                  width: "100%",
                                  maxWidth: 780,
                                  marginLeft: 0,
                                  marginRight: 0,
                                  display: "block",
                                }}
                              >
                                {DateDepartRetraite &&
                                  (() => {
                                    // Générer toutes les dates de départ + taux plein
                                    const allDates = [];

                                    // Ajouter les 6 dates de départ (année actuelle + 5 ans)
                                    for (let offset = 0; offset <= 5; offset++) {
                                      const date = new Date(DateDepartRetraite);
                                      date.setFullYear(date.getFullYear() + offset);
                                      allDates.push({ date, isTauxPlein: false });
                                    }

                                    // Insérer la date de taux plein
                                    if (DateDepartRetraiteTauxPlein && DateDepartRetraiteTauxPlein instanceof Date) {
                                      const tauxPleinTime = DateDepartRetraiteTauxPlein.getTime();
                                      
                                      // Insérer la date de taux plein au bon endroit
                                      const insertIndex = allDates.findIndex((d) => d.date.getTime() > tauxPleinTime);
                                      if (insertIndex !== -1) {
                                        allDates.splice(insertIndex, 0, { date: new Date(DateDepartRetraiteTauxPlein), isTauxPlein: true });
                                      } else {
                                        allDates.push({ date: new Date(DateDepartRetraiteTauxPlein), isTauxPlein: true });
                                      }
                                    }

                                    // Créer un tableau de toutes les clés de dates pour la logique de copie
                                    const allDateKeys = allDates.map(d => d.date.toISOString());

                                    return allDates.map((item, index) => {
                                      const dateKey = item.date.toISOString();
                                      const dateLabel = item.date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
                                      
                                      // Calculer l'âge pour cette ligne
                                      let ageAns, ageMois;
                                      if (item.isTauxPlein) {
                                        ageAns = ageDepartTauxPlein.ans;
                                        ageMois = ageDepartTauxPlein.mois;
                                      } else {
                                        // Pour les dates normales, calculer l'âge en fonction de l'offset
                                        const yearsOffset = item.date.getFullYear() - DateDepartRetraite.getFullYear();
                                        ageAns = ageDepartRetraite.ans + yearsOffset;
                                        ageMois = ageDepartRetraite.mois;
                                      }
                                      
                                      const ageLabel = ageMois > 0 ? `${ageAns} ans ${ageMois} mois` : `${ageAns} ans`;

                                      return (
                                        <li
                                          key={dateKey}
                                          style={{
                                            background: item.isTauxPlein ? "#fef3c7" : "#fff",
                                            borderRadius: "12px",
                                            boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                                            padding: "8px 0 8px 12px",
                                            marginBottom: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            position: "relative",
                                            border: item.isTauxPlein ? "1.5px solid #f59e0b" : "1.5px solid #d1d5db",
                                            transition: "box-shadow 0.2s",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontWeight: 600,
                                              fontSize: "12px",
                                              color: "#64748b",
                                              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                              width: 170,
                                              textAlign: "center",
                                              display: "inline-block",
                                            }}
                                          >
                                            {ageLabel}
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: 700,
                                              fontSize: "12px",
                                              color: item.isTauxPlein ? "#f59e0b" : "#6366f1",
                                              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                              width: 90,
                                              marginRight: 18,
                                              background: item.isTauxPlein ? "#fef3c7" : "#f1f5ff",
                                              border: item.isTauxPlein ? "1.5px solid #f59e0b" : "1.5px solid #6366f1",
                                              borderRadius: "8px",
                                              padding: "4px 12px",
                                              display: "inline-block",
                                              textAlign: "center",
                                            }}
                                          >
                                            {dateLabel}
                                          </span>
                                          <div style={{ width: 106, marginRight: 18, position: "relative" }}>
                                            {item.isTauxPlein && (
                                              <span
                                                style={{
                                                  fontSize: "11px",
                                                  color: "#f59e0b",
                                                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                                  fontWeight: 600,
                                                  background: "#fef3c7",
                                                  border: "1px solid #f59e0b",
                                                  borderRadius: "6px",
                                                  padding: "2px 8px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                Taux plein
                                              </span>
                                            )}
                                          </div>
                                          <TextField
                                            value={pensionsData[dateKey]?.pensionBrute || ""}
                                            dataType="uint"
                                            format={{ thousands: " ", unit: " €" }}
                                            onChange={(evt, value) => {
                                              // Vérifier si c'est la première saisie (toutes les autres sont vides)
                                              const hasOtherValues = allDateKeys.some(key => 
                                                key !== dateKey && pensionsData[key]?.pensionBrute
                                              );
                                              
                                              // Calculer la pension nette
                                              const prelevements = parseFloat(prelevementsSociaux) || 0;
                                              const pensionBrute = parseFloat(value) || 0;
                                              const pensionNette = pensionBrute - (pensionBrute * prelevements / 100);

                                              if (!hasOtherValues && value) {
                                                // C'est la première saisie, copier sur toutes les lignes
                                                const newData = {};
                                                allDateKeys.forEach(key => {
                                                  const itemData = allDates.find(d => d.date.toISOString() === key);
                                                  const itemLabel = itemData.date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
                                                  newData[key] = {
                                                    pensionBrute: value,
                                                    pensionNette: pensionNette.toFixed(0),
                                                    date: key,
                                                    dateLabel: itemLabel,
                                                    isTauxPlein: itemData.isTauxPlein
                                                  };
                                                });
                                                setPensionsData(newData);
                                              } else {
                                                // Saisie normale, mettre à jour uniquement cette ligne
                                                setPensionsData((prev) => ({
                                                  ...prev,
                                                  [dateKey]: {
                                                    ...prev[dateKey],
                                                    pensionBrute: value,
                                                    pensionNette: pensionNette.toFixed(0),
                                                    date: dateKey,
                                                    dateLabel: dateLabel,
                                                    isTauxPlein: item.isTauxPlein,
                                                  },
                                                }));
                                              }
                                            }}
                                            style={{
                                              width: "150px",
                                              marginRight: 18,
                                            }}
                                          />
                                          <TextField
                                            value={pensionsData[dateKey]?.pensionNette || ""}
                                            dataType="uint"
                                            format={{ thousands: " ", unit: " €" }}
                                            readOnly={true}
                                            style={{
                                              width: "150px",
                                              marginRight: 18,
                                            }}
                                          />
                                        </li>
                                      );
                                    });
                                  })()}
                              </ul>
                            </Column>
                          </Row>
                        </div>
                      </Row>
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: () => {
                // Construire le tableau avec les données
                const pensionsArray = Object.values(pensionsData)
                  .filter((p) => p.pensionBrute || p.pensionNette)
                  .map((p) => ({
                    pensionBrute: p.pensionBrute,
                    pensionNette: p.pensionNette,
                    date: p.date, // Conserver pour le tri
                    isTauxPlein: p.isTauxPlein,
                  }));

                // Séparer la ligne taux plein des autres
                const normalLines = pensionsArray.filter((p) => !p.isTauxPlein);
                const tauxPleinLine = pensionsArray.find((p) => p.isTauxPlein);

                // Trier les lignes normales par date
                normalLines.sort((a, b) => new Date(a.date) - new Date(b.date));

                // Construire le tableau final avec taux plein toujours en dernier
                const pensionsOrdered = [...normalLines];
                if (tauxPleinLine) {
                  pensionsOrdered.push(tauxPleinLine);
                }

                // Supprimer la propriété de date avant de sauvegarder
                const finalPensions = pensionsOrdered.map(({ date, ...pension }) => pension);

                // Mettre à jour le contexte
                const currentTab = context.state[props.Outil + "TabAutresPensions" + props.ClientConjoint] || [];
                
                if (editingPensionId) {
                  // Mode modification : mettre à jour l'objet existant
                  const updatedTab = currentTab.map(p => 
                    p.id === editingPensionId 
                      ? {
                          ...p,
                          libelle: libelle,
                          prelevementsSociaux: prelevementsSociaux,
                          pensions: finalPensions,
                        }
                      : p
                  );
                  context.handleValueChange(
                    [props.Outil + "TabAutresPensions" + props.ClientConjoint], 
                    updatedTab
                  );
                } else {
                  // Mode ajout : créer un nouvel objet
                  const pensionObject = {
                    id: Date.now() + Math.random().toString(36).substr(2, 9),
                    libelle: libelle,
                    prelevementsSociaux: prelevementsSociaux,
                    pensions: finalPensions,
                  };
                  context.handleValueChange(
                    [props.Outil + "TabAutresPensions" + props.ClientConjoint], 
                    [...currentTab, pensionObject]
                  );
                }

                // Réinitialiser les états locaux
                setPensionsData({});
                setLibelle("");
                setPrelevementsSociaux("0");
                setEditingPensionId(null);
                setmodalOpen(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
}

export default AutresPensionsModal;
